define("shared/components/shared/ui/icon-tooltip", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <span>
    <EmberTooltip
      @delay={{330}}
      @side="top"
    >
      {{@tooltip}}
    </EmberTooltip>
    {{svg-jar "help" class="o--icon"}}
  </span>
  
  */
  {
    "id": "bU8dboxL",
    "block": "[[[10,1],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[30,1]],[1,\"\\n  \"]],[]]]]],[1,\"\\n  \"],[1,[28,[35,1],[\"help\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@tooltip\"],false,[\"ember-tooltip\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/ui/icon-tooltip.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});